export default "__VITE_ASSET__BeVmm7ab__"